import { render, staticRenderFns } from "./ChooseTypeOfPixKey.vue?vue&type=template&id=5e024be0&scoped=true&"
import script from "./ChooseTypeOfPixKey.vue?vue&type=script&lang=js&"
export * from "./ChooseTypeOfPixKey.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTypeOfPixKey.vue?vue&type=style&index=0&id=5e024be0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e024be0",
  null
  
)

export default component.exports